// Derive a clean professional licence/area display name from a raw uploaded filename.
export function cleanName(name) {
  if (!name) return "Licence Area";
  let s = String(name).replace(/\.(kml|kmz|shp|zip|geojson|json|csv|tif|tiff)$/i, "");
  s = s.replace(/[_-]+/g, " ");
  s = s.replace(/\b(bold|outline|only|boundary|clip|clipped|final|new|copy|export)\b/gi, "");
  s = s.replace(/\b\d+[._]?\d*\s*km2?\b/gi, "");
  s = s.replace(/\s+/g, " ").trim();
  if (s.length < 3 || /^\d+$/.test(s.replace(/\s/g, ""))) return "Licence Area";
  return s || "Licence Area";
}

// Human-readable byte size.
export const fmtBytes = (n) => {
  if (!n || n <= 0) return "0 B";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
